import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { api } from '../api';
import Sidebar from './Sidebar';
import './layout.css';

const Layout = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) {
      navigate('/login');
      return;
    }
    fetchUserProfile();
  }, [token, navigate]);

  const fetchUserProfile = async () => {
    try {
      const response = await api.get('/api/auth/me', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setUserProfile(response.data);
    } catch (error) {
      console.error('Failed to fetch user profile:', error);
      // If token is invalid, redirect to login
      localStorage.removeItem('token');
      navigate('/login');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        backgroundColor: '#f8fafc'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
          <p style={{ fontSize: '16px', color: '#6b7280' }}>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="layout">
      <Sidebar
        userProfile={userProfile}
        onLogout={handleLogout}
        isOpen={sidebarOpen}
        onClose={closeSidebar}
      />
      <div className={`layout__content ${sidebarOpen ? 'layout__content--shifted' : ''}`}>
        <header className="layout__mobile-bar">
          <button
            className="layout__menu-btn"
            type="button"
            onClick={toggleSidebar}
            aria-label="Toggle navigation"
          >
            ☰
          </button>
        </header>
        <main className="layout__outlet">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
